import React from 'react';
import { _replaceRandom } from 'gsap/gsap-core';

import LazyLoad from 'react-lazyload';
import ImageLoader from '../common/ImageLoader'

import categories from '../db/categories';
import formatDate from '../common/dateFormatter'

const htmlTags = /<(.|\n)*?>/g


export default function ArticleBig(props) {

    return (

        <div className='article-big'>
            <LazyLoad
                placeholder={<div className='img-container'></div>}
                debounce={false}
                offsetVertical={300}
                overflow={false}
            >
                <a href={props.post.link}>
                    <figure className='img-container'>
                        <ImageLoader media={props.post.jetpack_featured_media_url} srcSet={props.srcSet} />
                    </figure></a>
            </LazyLoad>

            <div className='category'><p>
                {categories[props.post.categories]}
            </p></div>
            <h2><a href={props.post.link}>{props.post.title.rendered}</a></h2>
            <p className='summary'>{props.post.excerpt.rendered.replace(htmlTags, '')}</p>
            <p className='article-meta'>
                <a href={props.authorLink}>{props.author}</a>
                <time dateTime={props.post.date}>{formatDate(props.post.date)}</time></p>
        </div>
    );
}


